/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup, Card, CardHeader, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts,setCompanies, setCompanyUpdated, setContactUpdated, setQuoteLoading} from '../actions/quote'
import { toast } from 'react-toastify';
import { Tooltip } from 'reactstrap';

import {
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";


function Index(props) {
  const [company, setCompany] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [pwChangeConfirm, setPwChangeConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [userInfo, setUserInfo] = useState(false)
  const [email, setEmail] = useState("")  
  const [newPassword, setNewPassword] = useState("")
  const [newConfirmPassword, setNewConfirmPassword] = useState("")
  
  const toggletooltip = () => setTooltipOpen(!tooltipOpen);
  const deleteContact=()=>{
    props.setQuoteLoading(true);
    var bodyFormData = new FormData();
    axios.post(`/companies/deletecontact/${deleteId}`, bodyFormData).then(res => {
      setDeleteConfirm(false)
      const result = res.data;
      props.setContactUpdated(false)
      if(result.status == "success"){        
        toast.success("Your contact has been deleted");
        fetchCompany(props.selectedUser)
        props.setContactUpdated(true)
      }
      else{
        toast.error(result.data);
        props.setQuoteLoading(false);
      }
    }).catch(err => {
      props.setQuoteLoading(false);
      toast.error('Something was wrong. Try again');
    })
  }

  const submitPassword=()=>{
    if(newConfirmPassword != newPassword){
      toast.error("The password is not matching");
      return;
    }
    if(!email || email == ""){
      toast.error("The email is required");
      return;
    }
    props.setQuoteLoading(true);
    var bodyFormData = new FormData();
    bodyFormData.append('email', email);
    bodyFormData.append('password', newPassword);
    axios.post(`/users/setpassword/${props.selectedUser}`, bodyFormData).then(res => {
      setPwChangeConfirm(false)
      const result = res.data;
      if(result.status == "success"){        
        toast.success("The account has been changed");
      }
      else{
        toast.error(result.data);
      }
      props.setQuoteLoading(false);
    }).catch(err => {
      props.setQuoteLoading(false);
      toast.error('Something was wrong. Try again');
    })
  }

 
  useEffect(() => {
    if(props.selectedUser|| (props.selectedUser && (props.quote.contact_updated || props.quote.company_updated))){
      fetchCompany(props.selectedUser)
      fetchUser(props.selectedUser)
    }
    else{      
      setCompany(null)
      setContacts([])
    }
  },[props.selectedUser,props.quote.contact_updated, props.quote.company_updated]);

  const fetchCompany = (userid)=>{
    props.setQuoteLoading(true);
    axios.get(`/companies/getcompanybyuser/${userid}`).then(res => {
      props.setQuoteLoading(false);
      console.log('res.data',res.data)
      if(res.data.status == "success"){  
        setCompany( res.data.data)
        if(res.data.data){
          setContacts(res.data.data.contacts)
        }
        else{
          setContacts([])
        }
      }
    })    
  }

  const fetchUser = (userid)=>{
    props.setQuoteLoading(true);
    axios.get(`/users/view/${userid}`).then(res => {
      if(res.data.status == "success"){  
        var user = res.data.data
        setEmail(user['email'])
      }
    })    
  }

  const getuserid=()=>{
    var userid = null;
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
      console.log('getuser', userinfo);
      if(role == 'admin'){
        userid = props.selectedUser
      }
      else{
        userid = userinfo['id'];
      }
    }
    return userid;
  }
  const getuserrole=()=>{
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
    }
    return role;
  }

  return (
    <Row className="m-0 company-container">
      <Col md="4" className="border-right-3 p-0">
        <Card className="bg-white border-0">
          <div className="company-sub-header1">
            <span>Company</span>
            <label className="help-icon reverse" style={{margin:"2px 0 0 10px"}} href="#" id={`subheader-company-label`}>i</label>
          </div>
          <CardBody className="">
            <div className="">
                {company &&
                  <div className="position-relative">
                    <div className="mb-0">
                      <b>{company['company']?<>{company['company']}<br/></>:""}</b>
                      {company['email']?<>{company['email']}<br/><br/></>:""}
                      {company['mobile']?<>{company['mobile']}<br/><br/></>:""}
                      {(company['address']?<>{(company['address']+", ")}<br/></>:"")}
                      {(company['suburb']?(company['suburb']+", "):"")+(company['state']?(company['state']+", "):"")+(company['postcode']?company['postcode']:"")}<br/>
                      {company['web']?<>{company['web']}<br/><br/></>:""}
                      {company['referral']?<>{company['referral']}<br/></>:""}
                    </div>
                  </div>
                }
            </div>
            {props.selectedUser && 
            <Card className="bg-white">
              <CardBody style={{padding:'1rem 1.5rem'}}>
                <h6 className="mt-0 mb-2 font-weight-bold">Change Account</h6>
                <FormGroup row>
                  <Col sm={5}>
                    <label size="sm">Email:</label>
                  </Col>
                  <Col sm={7}>
                    <Input type="email" bsSize="sm" name="email" value={email} onChange={(e)=>setEmail(e.target.value)} autoComplete="off" placeholder="email"/> 
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={5}>
                    <label size="sm">New Password:</label>
                  </Col>
                  <Col sm={7}>
                    <Input type="password" bsSize="sm" name="new_password" value={newPassword} onChange={(e)=>setNewPassword(e.target.value)}/> 
                  </Col>
                </FormGroup>
                <FormGroup row> 
                  <Col sm={5}>
                    <label size="sm">Confirm Password:</label>
                  </Col>
                  <Col sm={7}>
                    <Input type="password" bsSize="sm" name="new_password_confirm" value={newConfirmPassword} onChange={(e)=>setNewConfirmPassword(e.target.value)}/> 
                  </Col>
                </FormGroup>
                <FormGroup className="text-right mb-0">
                  <Button  className="" color="primary" size="sm" onClick={()=>setPwChangeConfirm(true)}>Change</Button>
                </FormGroup>
              </CardBody>
            </Card>
            }
          </CardBody>
        </Card>
        <Tooltip placement="bottom" isOpen={tooltipOpen} className="text-left" target="subheader-company-label" toggle={toggletooltip}>
          In this section you can edit your company profile details - such as adding a new contact 
        </Tooltip>
      </Col>
      <Col md="8" className="p-0">
        <Card className="bg-white border-0">
          <div className="company-sub-header2">
            Contact
          </div>
          <CardBody className="">
            <Row>
              {
                contacts.map((row, index)=>{
                  return (
                    <Col md={6} className="position-relative">
                      <div className="contact-item d-flex">
                        <div style={{width:'calc(100% - 40px)'}}>
                          <b>{(row['firstname']?row['firstname']:'')+" "+(row['lastname']?row['lastname']:"")}</b><br/>
                          <b>{row['company_name']}</b>
                          {row['primary_set']&&
                            <span> (primary)</span>
                          }
                          <br/>
                          {row['mobile']} {row['mobile']&&row['phone']?"/":""} {row['phone']}<br/>
                          {row['email']}<br/>
                        </div>
                        <div className="contact-remove">
                          <i style={{fontSize:17, cursor:'pointer'}} className="fa fa-trash" onClick={()=>{setDeleteConfirm(true); setDeleteId(row['id'])}}></i>
                        </div>
                      </div>
                    </Col>
                  )
                })
              }
            </Row>
          </CardBody>
        </Card>
      </Col>
      <Modal isOpen={deleteConfirm} toggle={()=>setDeleteConfirm(false)} >
        <ModalHeader toggle={()=>setDeleteConfirm(false)}>Confirm</ModalHeader>
        <ModalBody>
          Are you sure to delete this contact?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" size="sm" onClick={()=>deleteContact()}>Yes</Button>{' '}
          <Button color="secondary" size="sm" onClick={()=>setDeleteConfirm(false)}>No</Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={pwChangeConfirm} toggle={()=>setPwChangeConfirm(false)} >
        <ModalHeader toggle={()=>setPwChangeConfirm(false)}>Confirm</ModalHeader>
        <ModalBody>
          Are you sure you want to change the password?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" size="sm" onClick={()=>submitPassword()}>Yes</Button>{' '}
          <Button color="secondary" size="sm" onClick={()=>setPwChangeConfirm(false)}>No</Button>
        </ModalFooter>
      </Modal>
    </Row>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    setCompanies: companies=>dispatch(setCompanies(companies)),
    setCompanyUpdated: value=>dispatch(setCompanyUpdated(value)),
    setContactUpdated: value=>dispatch(setContactUpdated(value)),
    setQuoteLoading: value=>dispatch(setQuoteLoading(value))
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
